import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { z } from 'zod';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';
import { requireSystemAdmin } from '~/utils/guards';

/**
 * ClickHouse table browser route (`/explorer/clickhouse`). Super-admin only
 * — exposes the raw analytics database. Lazy-loaded so it stays off the initial
 * authenticated bundle.
 */
const ClickhouseBrowserPage = lazy(
  () => import('~/features/explorer/pages/clickhouse-browser-page'),
);

// Declares the section-wide subsidiary scope (`sc`) so the Explorer tab bar can
// carry the picked subsidiary onto this route — matches the sibling routes.
const searchSchema = z.object({
  sc: z.string().optional(),
});

export const Route = createFileRoute('/_authenticated/_tenant/explorer/clickhouse')({
  validateSearch: searchSchema,
  beforeLoad: requireSystemAdmin(),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Suspense fallback={<PageSkeleton />}>
      <ClickhouseBrowserPage />
    </Suspense>
  );
}
